import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Form from "react-bootstrap/Form";
import ConfirmCode from "./ConfirmCode/ConfirmCode";
import DataClient from "./DataClient/DataClient";
import useUser from "../../../hooks/useUser";
import { useNavigate } from "react-router";
import {
  img1CarruselDesktop,
  img1CarruselMobile,
  pinguinoAzulRegistro,
} from "../../../assets/ImgLinks";
import SendEmailCodeButton from "./SendEmailCodeButton";
import UserExists from "./UserExists";
import { Spinner } from "react-bootstrap";
import "../../../assets/animaciones.css";

const expresionEmail = /^\w+([._-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

// const expresionEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

//  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const initialDataConfirmEmail = {
  email: "",
  code: "",
  confirmCode: "",
};

const MyForm = () => {
  const [
    dataUser,
    setDataUser,
    dataAdmin,
    setDataAdmin,
    initialDataUser,
    dataLocalStorage,
    setDataLocalStorage,
  ] = useUser();
  const navigate = useNavigate();

  const [confirmEmail, setConfirmEmail] = useState(initialDataConfirmEmail);
  const [checkConfirmCode, setCheckConfirmCode] = useState(false);
  const [hideEmail, setHideEmail] = useState(false);

  const [isValidEmail, setIsValidEmail] = useState(false);
  const [hideDataClient, setHideDataClient] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {}, [
    dataUser?.dataID?.idAptos,
    dataUser?.dataID?.idCL,
    dataUser?.dataID?.idMF,
  ]);
  useEffect(() => {
    if (
      dataLocalStorage?.email !== "default" &&
      dataLocalStorage?.email !== "" &&
      dataLocalStorage?.email !== undefined
    ) {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [dataLocalStorage]);

  useEffect(() => {
    if (dataUser.pageReload) {
      setConfirmEmail(initialDataConfirmEmail);
      setHideEmail(false);
      setIsValidEmail(false);
      setCheckConfirmCode(false);
      setDataUser({
        ...dataUser,
        pageReload: false,
      });
    }

    if (confirmEmail.code) {
      //console.log(confirmEmail.code);
      //setSendingMail(false);
      setHideEmail(true);
    }

    if (
      dataUser.dataID?.idAptos &&
      dataUser.dataID?.idCL &&
      dataUser.dataID?.idMF
    ) {
      navigate("/");
      setHideEmail(false);
      setHideDataClient(true);
    }

    //validacion del codigo
    if (
      confirmEmail.code !== "" &&
      confirmEmail.code === confirmEmail.confirmCode
    )
      setCheckConfirmCode(true);
    else setCheckConfirmCode(false);
  }, [confirmEmail.confirmCode, confirmEmail.code, dataUser.dataID]);

  useEffect(() => {
    //validacion del formato email
    if (validateEmail(confirmEmail.email)===true){

      if(isValidEmail===false){
        setIsValidEmail(true);
      }
      
    } 
    else {
      if(isValidEmail===true){
        setIsValidEmail(false);
      }
      
    }
  }, [confirmEmail.email]);
  useEffect(() => {
    if (isValidEmail) {
      setDataUser({
        ...dataUser,
        email: confirmEmail.email,
      });
    }
  }, [isValidEmail]);

  const validateEmail = (email) => {
    const isGeneralEmail = expresionEmail.test(String(email).toLowerCase());
    const emailTo = email.toLowerCase().includes("mailto:");
    const beforeArroba= email.split('@')[0];
    const expresionLetter = /[a-z]/;
    const includesLetter = expresionLetter.test(String(beforeArroba).toLowerCase());
    if (isGeneralEmail === true && !emailTo && includesLetter) {
      return true;
    } else {
      return false;
    }
  };

  const handleChangeEmail = (e) => {
    e.preventDefault();

    setConfirmEmail({
      ...confirmEmail,
      email: e.target.value,
    });

     if (dataUser.dataID?.idAptos!=='' && dataUser.dataID?.idCL!=='' && dataUser.dataID?.idMF!=='') {
      setCheckConfirmCode(false);
      setDataUser({
        ...initialDataUser,
        email: e.target.value,
      });

      if (confirmEmail.code !== "") {
        setConfirmEmail({
          ...confirmEmail,
          code: "",
          confirmCode: "",
        });
      }
      setHideDataClient(false);
    } 

    if (isValidEmail && dataUser.succedRegister===true) {
      setDataUser({
        ...dataUser,
        succedRegister: false,
      });
    }
  };

  const setConfirmCode = (code) => {
    //console.log('el codigo tecleado para confirmacion(code) es:',code)
    setConfirmEmail({
      ...confirmEmail,
      confirmCode: parseInt(code),
    });
  };

  return (
    <div>
      {!hideEmail && (
        <Form className="row pt-3 pb-3">
          <Container className="getUserEmail col-sm-12 col-md-8 col-lg-6 ">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="fw-bold">Ingresar Email</Form.Label>
              <Form.Control
                value={confirmEmail.email}
                onChange={handleChangeEmail}
                type="email"
                placeholder="email"
              />
              <Form.Text className="text-muted">
                Aqui te enviaremos tu código de confirmación.
              </Form.Text>
            </Form.Group>
          </Container>
          <SendEmailCodeButton
            isValidEmail={isValidEmail}
            confirmEmail={confirmEmail}
            setConfirmEmail={setConfirmEmail}
          />
        </Form>
      )}
      {isValidEmail &&
        dataUser.dataID?.idAptos &&
        dataUser.dataID?.idCL &&
        dataUser.dataID?.idMF && <UserExists />}
      {!checkConfirmCode && confirmEmail.code && hideEmail && (
        <ConfirmCode
          setConfirmCode={setConfirmCode}
          codeToConfirm={confirmEmail.code}
        />
      )}

      {!dataUser.succedRegister &&
        checkConfirmCode &&
        !hideDataClient &&
        !dataUser.registerComplete && <DataClient />}

      {dataUser.succedRegister && (
        <div className="pt-3 pb-5">
          <h1 className="text-danger text-center fs-5 mt-4">
            Bienvenido MinisoLover
          </h1>
          <h4 className="text-secondary fs-6 mt-4 text-center">
            Tu Cupón sera enviado a: {dataUser.email}
          </h4>
          <div className="d-flex justify-content-center align-items-center my-4">
            <Spinner />
          </div>
          <img
            style={{ width: "100px", animation: "heartBeat 1s infinite" }}
            className="d-block me-auto ms-auto"
            src={pinguinoAzulRegistro}
            alt="imgLogo"
          />
          <img
            className="d-none d-lg-block w-100 mt-3"
            src={img1CarruselDesktop}
            alt="img1Carrusel"
          />
          <img
            className="d-block d-lg-none w-100 mt-3"
            src={img1CarruselMobile}
            alt="img1Carrusel"
          />
        </div>
      )}
    </div>
  );
};

export default MyForm;
